import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";
import { Overview } from "./admin/Overview";
import { Artworks } from "./admin/Artworks";
import { BusinessCollections } from "./admin/Business";
import { Sales } from "./admin/Sales";
import { Messages, Requests, Reviews, Media, Contacts } from "./admin/Community";
import { Categories } from "./admin/Categories";
import { Content } from "./admin/Content";
import { GelatoAdmin } from "./admin/Gelato";
import { SiteImagesAdmin, ArtistPhotosAdmin } from "./admin/SiteImages";
import { EmailLogAdmin } from "./admin/EmailLog";
import { VideosAdmin } from "./admin/Videos";
import { SocialAdmin } from "./admin/Social";

const SECTIONS = ["Overview", "Artworks", "Business Collections", "Categories", "Sales", "Prints (Gelato)", "Messages", "Requests", "Reviews", "Media", "Site Images", "Artist Photos", "Videos", "Social Studio", "Email Log", "Contacts", "Content"];

export default function AdminDashboardPage() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [section, setSection] = useState("Overview");

  return (
    <div className="admin-app flex min-h-screen font-body">
      <aside className="w-60 border-r border-white/10 py-8 px-4 flex flex-col">
        <div className="font-serif text-xl px-2 mb-1 text-white">Fine Art by Jason</div>
        <div className="overline text-white/40 px-2 mb-10">Studio Console</div>
        <nav className="flex flex-col gap-1 flex-1">
          {SECTIONS.map(s => (
            <button key={s} onClick={() => setSection(s)} data-testid={`admin-nav-${s.toLowerCase()}`}
              className={`text-left px-3 py-2 text-sm font-mono-brand transition ${section === s ? "bg-white text-black" : "text-white/70 hover:bg-white/5"}`}>
              {s}
            </button>
          ))}
        </nav>
        <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout"
          className="flex items-center gap-2 text-xs text-white/50 hover:text-white px-3 py-2">
          <LogOut size={14}/> Sign out
        </button>
      </aside>
      <main className="flex-1 p-8 md:p-12 max-w-full overflow-x-hidden">
        {section === "Overview" && <Overview />}
        {section === "Artworks" && <Artworks />}
        {section === "Business Collections" && <BusinessCollections />}
        {section === "Categories" && <Categories />}
        {section === "Sales" && <Sales />}
        {section === "Prints (Gelato)" && <GelatoAdmin />}
        {section === "Messages" && <Messages />}
        {section === "Requests" && <Requests />}
        {section === "Reviews" && <Reviews />}
        {section === "Media" && <Media />}
        {section === "Site Images" && <SiteImagesAdmin />}
        {section === "Artist Photos" && <ArtistPhotosAdmin />}
        {section === "Videos" && <VideosAdmin />}
        {section === "Social Studio" && <SocialAdmin />}
        {section === "Email Log" && <EmailLogAdmin />}
        {section === "Contacts" && <Contacts />}
        {section === "Content" && <Content />}
      </main>
    </div>
  );
}

